import styled, { css } from 'styled-components';

// Tabela padrão do sistema (listas, grid de itens e relatórios)

export const TabelaContainer = styled.div`
  width: 100%;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};
  background-color: ${({ theme }) => theme.cores.card};
  -webkit-overflow-scrolling: touch;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: ${({ theme }) => theme.fonte.body};
  text-align: left;
`;

export const Th = styled.th<{ $numero?: boolean; $ordenavel?: boolean; $ordenado?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 12px;
  background-color: ${({ theme }) => theme.cores.surface};
  border-bottom: 1px solid ${({ theme }) => theme.cores.border};
  color: ${({ $ordenado, theme }) => ($ordenado ? theme.cores.primary : theme.cores.inkSecondary)};
  font-size: ${({ theme }) => theme.fonte.caption};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  text-align: ${({ $numero }) => ($numero ? 'right' : 'left')};
  white-space: nowrap;
  user-select: none;

  ${({ $ordenavel, theme }) => $ordenavel && css`
    cursor: pointer;

    &:hover {
      color: ${theme.cores.ink};
    }
  `}

  svg {
    margin-left: 4px;
    vertical-align: -1px;
  }
`;

export const Td = styled.td<{ $numero?: boolean }>`
  padding: 10px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.cores.border};
  color: ${({ theme }) => theme.cores.ink};
  text-align: ${({ $numero }) => ($numero ? 'right' : 'left')};
  font-variant-numeric: ${({ $numero }) => ($numero ? 'tabular-nums' : 'normal')};
  white-space: nowrap;
`;

export const Tr = styled.tr<{ $selecionado?: boolean; $clicavel?: boolean }>`
  background-color: ${({ $selecionado, theme }) => ($selecionado ? theme.cores.selecionado : theme.cores.card)};
  cursor: ${({ $clicavel }) => ($clicavel ? 'pointer' : 'default')};
  transition: background-color 0.1s ease;

  td:first-child {
    box-shadow: ${({ $selecionado, theme }) => ($selecionado ? `inset 3px 0 0 ${theme.cores.primary}` : 'none')};
  }

  &:last-child td {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ $selecionado, theme }) => ($selecionado ? theme.cores.selecionado : theme.cores.surface)};
  }
`;

export const TabelaVazia = styled.div`
  padding: ${({ theme }) => theme.espaco.xl};
  color: ${({ theme }) => theme.cores.inkMuted};
  text-align: center;
`;

// Casas decimais de um número: laytel.pre; sem pre, inteiro sem casas e fracionário com 2
export function casasDecimais(valor: number, pre?: string | number): number {
  if (pre !== undefined && pre !== null && String(pre).trim() !== '' && !isNaN(Number(pre))) {
    return Math.max(0, Math.min(10, Number(pre)));
  }
  return Number.isInteger(valor) ? 0 : 2;
}

// Formata o valor de uma célula (a API às vezes devolve array/objeto, ex.: estoque e preço do mercador).
// Números em pt-BR com as casas do laytel.pre; campos de código (cod*) sem separador de milhar
export function valorCelula(valor: any, pre?: string, nomeCampo?: string): string {
  if (valor === null || valor === undefined) return '';
  if (Array.isArray(valor)) return 'Array';
  if (typeof valor === 'object') return 'Object';
  if (typeof valor === 'number') {
    const casas = casasDecimais(valor, pre);
    return valor.toLocaleString('pt-BR', {
      minimumFractionDigits: casas,
      maximumFractionDigits: casas,
      useGrouping: !nomeCampo?.toLowerCase().startsWith('cod')
    });
  }
  return String(valor);
}

// Valor numérico para um <input> da ficha: mesmas casas da lista, com ponto e sem milhar
export function valorInput(valor: number, pre?: string): string {
  return valor.toFixed(casasDecimais(valor, pre));
}

export function ehNumero(valor: any): boolean {
  return typeof valor === 'number';
}
